import request from '@/utils/request'
let preBase = 'mixApi'

// 宿迁民丰加油满减领券-登录
export const login = (data) => {
  return request({
    url: `${preBase}/minfengBankRecord/login`,
    method: 'post',
    data,
    custom: true,
    hideLoading: true,
  })
}
// 宿迁民丰加油满减领券-领券
export const issuingVouchers = (data) => {
  return request({
    url: `${preBase}/minfengBankRecord/issuingVouchers`,
    method: 'post',
    token: sessionStorage.getItem('minfengBankRecordToken'),
    data,
  })
}
// 宿迁民丰加油满减领券-校验
export const check = (data) => {
  return request({
    url: `${preBase}/minfengBankRecord/check`,
    method: 'post',
    token: sessionStorage.getItem('minfengBankRecordToken'),
    data,
  })
}

// 宿迁民丰加油满减领券-埋点
export const addPointData = (data) => {
  return request({
    url: `${preBase}/minfengBankRecord/addPointData`,
    method: 'post',
    token: sessionStorage.getItem('minfengBankRecordToken'),
    data,
  })
}

